import React, { useState, useEffect } from "react";
import axios from "axios";
import ClipLoader from "react-spinners/ClipLoader";
import AddIcon from '@mui/icons-material/Add';
import rightarrow from '../Assets/navbar/right-arrow.svg'
import { useLocation, useNavigate } from "react-router-dom";
// import img6 from '../Assets/add/img6.png'
import { Alert } from '@mui/material';
import { ChevronDown, ChevronUp, Trash2 } from 'lucide-react';
import rightArrow from "../Assets/navbar/right-arrow.svg";
import { ArrowLeft, CircleDashed, User } from 'lucide-react';

// import img6 from '../../Assets/home/img4.png'
const config = {
    cUrl: 'https://api.countrystatecity.in/v1/countries/IN',
    ckey: 'NHhvOEcyWk50N2Vna3VFTE00bFp3MjFKR0ZEOUhkZlg4RTk1MlJlaA=='
};

const ViewDetails = () => {
    const { state } = useLocation();
    const navigate = useNavigate();
    console.log("Received:", state?.mobileNo);
    const [states, setStates] = useState([]);
    const [cities, setCities] = useState([]);
    const [isLoadingStates, setIsLoadingStates] = useState(true);
    const [isLoadingCities, setIsLoadingCities] = useState(true);
    const [alertInfo, setAlertInfo] = useState({ show: false, message: '', severity: 'info' });
    const [isOpenImage, setIsOpenImage] = useState({});


    const [storedVehicleNos, setStoredVehicleNos] = useState([]);
    const [tempVehicleNo, setTempVehicleNo] = useState("");
    const [data, setData] = useState({});
    const [modalImage, setModalImage] = useState(null)
    // temporary input
    const [reasonForRejection, setReasonOfRejection] = useState(null)
    const [isRejected, setIsRejected] = useState(false)
    const [imageReasonMap, setImageReasonMap] = useState(null)
    const [parsedReasons, setParsedReasons] = useState(null)
    console.log('imagereasonmap', imageReasonMap)



    const [formData, setFormData] = useState({
        loginMobile: '',
        vehicleNo: [],
        vendorName: "",
        city: "",
        state: "",
        vendorPhone: "",
        fatherName: '',
        address: '',
        companyName: '',
        ReasonOfRejection: "",
        chooseFromSelectedService: null,
        driverNames: '',
        driverNumbers: '',
        driverDLNos: '',
        driverDOBs: '',
    });
    console.log('formdata', formData)
    const [images, setImages] = useState({});
    console.log('images', images)

    const getDataById = async (id) => {
        try {
            console.log(`${process.env.REACT_APP_BACKEND_URL}/api/data/${id}`)
            const response = await axios.get(
                `${process.env.REACT_APP_BACKEND_URL}/api/data1/${id}/${state?.vehicleNo}`,
            );
            const fetchedData = response.data;
            console.log('fetched', fetchedData.data)
            setData(fetchedData.data); // Save raw if needed

            // Prefill form fields
            const vehicleArray = fetchedData.data.vehicleNo.split(',')
            console.log('fetchedData.vehicleNo', vehicleArray, state?.vehicleNo)

            setFormData({
                vehicleNo: vehicleArray.filter((vh) => vh == state?.vehicleNo) || "",
                vendorName: fetchedData.data.vendorName || "",
                vendorPhone: fetchedData.data.vendorPhone || "",
                fatherName: fetchedData.data.fatherName || "",
                address: fetchedData.data.address || "",
                state: fetchedData.data.state || "",
                city: fetchedData.data.district || "",
                companyName: fetchedData.data.companyName || "",
                typeOfAgreement: fetchedData.data.typeOfAgreement,
                driverNames: fetchedData.data.driverNames,
                driverNumbers: fetchedData.data.driverNumbers,
                driverDLNos: fetchedData.data.driverDLNos,
                driverDOBs: fetchedData.data.driverDOBs,


            });


            // Prefill image fields
            const initialImages = {};
            const keys = [];

            console.log('fetchedData.data.images', fetchedData.data.images)
            if (fetchedData.data.images) {
                for (const [key, value] of Object.entries(fetchedData.data.images)) {
                    if (value) {
                        initialImages[key] = value;
                        keys.push(key);
                    }
                }
            }

            setImages(initialImages);
            setImageKeys(keys);
            console.log('state?.details')
            console.log('state?.details', state?.details)
            if (state?.details === 'reject') {
                const reasonForRejectionMap = fetchedData.data.ReasonOfRejectionMap || {};
                const reasonString = reasonForRejectionMap[state?.vehicleNo] || "";
                console.log('ReasonOfRejection:', reasonString);
                setReasonOfRejection(reasonString);
                setIsRejected(true);
                setIsNotReadOnly(true)

                const normalizeKey = (raw) => {
                    return raw
                        .toLowerCase()
                        .replace(/\s+/g, " ")                            // Collapse multiple spaces
                        .replace(/\s*-\s*/g, " -")                       // Normalize dash spacing
                        .replace(/([A-Z])\s(?=[A-Z0-9])/gi, "$1")         // Remove space inside plate
                        .replace(/([0-9])\s(?=[A-Z])/gi, "$1")            // Remove space between number and letter
                        .replace(/([A-Z]{2})\s?([0-9]{2})\s?([A-Z]{1,2})\s?([0-9]{3,4})/gi, "$1$2$3$4") // Compact plates
                        .trim();
                };

                const imageKeysFromBackend = Object.keys(fetchedData.data.images || {});
                const normalizedImageKeyMap = {};

                // Build a mapping of normalized → original backend keys
                imageKeysFromBackend.forEach((originalKey) => {
                    const normalized = normalizeKey(originalKey);
                    normalizedImageKeyMap[normalized] = originalKey;
                });

                // Step 1: Parse reason string into normalized key → reason map
                let reasonMap = {};
                const pointedReasons = reasonString
                    .split('•')
                    .map((str) => str.trim())
                    .filter(Boolean);

                pointedReasons.forEach((entry) => {
                    if (entry.includes(":")) {
                        const [rawKey, ...rest] = entry.split(":");
                        const normalizedKey = normalizeKey(rawKey);
                        const backendKey = normalizedImageKeyMap[normalizedKey]; // Match normalized reason to backend key
                        const value = rest.join(":").trim();

                        if (backendKey) {
                            reasonMap[backendKey] = value; // Use actual backend key for matching
                        } else {
                            reasonMap[rawKey.trim()] = value; // Keep raw key if not matched
                        }
                    } else {
                        reasonMap["other"] = (reasonMap["other"] || "") + " " + entry;
                    }
                });

                console.log("Mapped Reasons:", reasonMap);
                console.log("Fetched Images:", fetchedData.data.images);

                // Step 2: Build imageReasonMap from matched keys
                const imageReasonMap = {};
                Object.entries(fetchedData.data.images || {}).forEach(([key, url]) => {
                    if (reasonMap[key]) {
                        imageReasonMap[key] = {
                            url,
                            reason: reasonMap[key],
                        };
                    }
                });

                console.log("Filtered Image Reason Map:", imageReasonMap);

                setParsedReasons(reasonMap);         // all reasons (including "other")
                setImageReasonMap(imageReasonMap);   // only images with matching reasons
            }


            // setTypeOfAgreement(fetchedData.data.typeOfAgreement || "individual");
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    useEffect(() => {
        if (
            formData.driverNames &&
            formData.driverNumbers &&
            Array.isArray(formData.vehicleNo) &&
            formData.vehicleNo.length > 0
        ) {
            const prefilledData = {};
            formData.vehicleNo.forEach((vehicle) => {
                prefilledData[`driverName-${vehicle}`] = formData.driverNames[vehicle] || "";
                prefilledData[`driverNumber-${vehicle}`] = formData.driverNumbers[vehicle] || "";
                prefilledData[`driverDLNos-${vehicle}`] = formData.driverDLNos[vehicle] || "";

            });

            setFormData((prev) => ({
                ...prev,
                ...prefilledData,
            }));
        }
    }, [formData.driverNames, formData.driverNumbers, formData.driverDLNos, formData.vehicleNo]);



    // Fetch on mount
    useEffect(() => {
        console.log('state?.id', state?.id)
        if (state?.id) {
            getDataById(state?.id);
        }

    }, [state]);

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isNotReadOnly, setIsNotReadOnly] = useState(false);
    console.log('isnotreadly', isNotReadOnly)
    const [nextPage, setNextPage] = useState(1);
    const [submittedVehicles, setSubmittedVehicles] = useState([]);

    const [imageKeys, setImageKeys] = useState([
        "Photo of the Owner",
        "Adhar Card Front",
        "Adhar Card Back",
        "Pan Card",
        "GST",
        "Cancelled cheque",
        // "RC",
        // "Insurance",
        // "Front Vehicle",
        // "Rear Vehicle",
        // "Right Side",
        // "Left Side",


        ...Array.from({ length: 0 }, (_, i) => `image${i + 1}`),
    ]);

    const [imageKeysForVehicle, setImageKeysForVehicle] = useState([
        "RC",
        "Insurance",
        "Front Vehicle Image",
        "Rear Vehicle Image",
        "Right Side Image",
        "Left Side Image",
    ])

    const [imageKeysCompany, setImageKeysCompany] = useState([
        "Photo of the Owner",
        "Adhar Card Front",
        "Adhar Card Back",
        "Pan Card",
        "GST",
        "Cancelled cheque",
        "RC",
        "Insurance",
        "Front Vehicle Image",
        "Rear Vehicle Image",
        "Right Side Image",
        "Left Side Image",
        "MOA",
        "Partnership Deed or Company Registration Certificate",

        ...Array.from({ length: 0 }, (_, i) => `image${i + 1}`),
    ]);

    const [isSubmitting, setIsSubmitting] = useState(false);






    const loadStates = () => {
        setIsLoadingStates(true);
        fetch(`${config.cUrl}/states`, {
            headers: { "X-CSCAPI-KEY": config.ckey }
        })
            .then(response => response.json())
            .then(data => {
                setStates(data);
                setIsLoadingStates(false);
            })
            .catch(error => {
                console.error('Error loading states:', error);
                setIsLoadingStates(false);
            });
    }


    const loadCities = (stateCode) => {
        setIsLoadingCities(true);
        fetch(`${config.cUrl}/states/${stateCode}/cities`, {
            headers: { "X-CSCAPI-KEY": config.ckey }
        })
            .then(response => response.json())
            .then(data => {
                setCities(data);
                setIsLoadingCities(false);
            })
            .catch(error => {
                console.error('Error loading cities:', error);
                setIsLoadingCities(false);
            });
    };



    useEffect(() => {
        console.log('state?.mobileNo', state?.mobileNo)
        loadStates();
        if (state?.mobileNo) {
            setFormData(prev => ({
                ...prev,
                login_mobile: state?.mobileNo
            }))
        }
        const hasVisited = sessionStorage.getItem("hasVisitedModal");
        if (!hasVisited) {
            setIsModalOpen(true); // show modal on first visit
            sessionStorage.setItem("hasVisitedModal", "true"); // set flag so it won't show again
        }
    }, [state]);





    const toggleVehicleImage = (vehicleNo) => {
        setIsOpenImage((prev) => ({
            ...prev,
            [vehicleNo]: !prev[vehicleNo],
        }));
    };

    useEffect(() => {
        if (formData?.vehicleNo?.length) {
            const initialState = {};
            formData.vehicleNo.forEach((no) => {
                initialState[no] = true; // open by default
            });
            setIsOpenImage(initialState);
        }
    }, [formData.vehicleNo]);

    const handleInputChange = (e) => {
        if (e.target.name === 'state') {
            loadCities(e.target.value);
        }

        setFormData((prev) => ({
            ...prev,
            [e.target.name]: e.target.value
        }));
    };

    const handleAddVehicleNo = () => {
        const newVehicle = tempVehicleNo.trim();
        if (newVehicle && !formData.vehicleNo.includes(newVehicle)) {
            setStoredVehicleNos([...storedVehicleNos, newVehicle]);
            setFormData((prevData) => ({ ...prevData, vehicleNo: [...(prevData.vehicleNo || []), newVehicle] }));
            setTempVehicleNo(""); // clear input
        }
    };

    const MAX_SIZE_MB = 1;
    const MAX_SIZE_BYTES = MAX_SIZE_MB * 1024 * 1024;
    const [newImages, setNewImages] = useState({})
    console.log('newimages', newImages)
    const handleImageChange = async (key, file) => {
        if (!file) return;

        setManuallySelectedKeys((prev) => new Set(prev).add(key));
        try {
            const compressedFile = await compressFile(file);
            console.log('compressedFile.size', compressedFile.size)
            if (compressedFile.size > MAX_SIZE_BYTES) {
                alert('Image should be less than 1 MB.');
                return;
            }
            console.log('key123', key)
            setNewImages((prev) => ({
                ...prev,
                [key]: compressedFile,
            }));
            setImages((prev) => ({
                ...prev,
                [key]: compressedFile,
            }));
        } catch (error) {
            console.error("Image compression error:", error);
            alert("Failed to process image.");
        }
    };




    const compressFile = (file) => {
        return new Promise((resolve, reject) => {
            // Allow image compression only for image types
            if (file.type.startsWith("image/")) {
                const reader = new FileReader();

                reader.onload = (event) => {
                    const img = new Image();
                    img.onload = () => {
                        const canvas = document.createElement("canvas");

                        const scale = Math.min(800 / img.width, 800 / img.height, 1);
                        canvas.width = img.width * scale;
                        canvas.height = img.height * scale;

                        const ctx = canvas.getContext("2d");
                        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

                        canvas.toBlob(
                            (blob) => {
                                if (blob) {
                                    const compressedFile = new File([blob], file.name, { type: file.type });
                                    if (compressedFile.size <= 1024 * 1024) {
                                        resolve(compressedFile);
                                    } else {
                                        reject(new Error("Image should be less than 1MB even after compression."));
                                    }
                                } else {
                                    reject(new Error("Compression failed"));
                                }
                            },
                            file.type,
                            0.7
                        );
                    };
                    img.onerror = reject;
                    img.src = event.target.result;
                };

                reader.onerror = reject;
                reader.readAsDataURL(file);
            } else {
                // For non-image files, check file size only
                if (file.size <= 1024 * 1024) {
                    resolve(file);
                } else {
                    reject(new Error("Document should be less than 1MB."));
                }
            }
        });
    };
    const [openConfirmationModal, setOpenConfirmationModal] = useState(false);
    const [openValidationModal, setOpenValidationModal] = useState(false);

    const readyToSubmit = (e) => {
        e.preventDefault();
        if (Object.keys(imageReasonMap).length !== Object.keys(newImages).length) {
            setOpenValidationModal(true);
            return;
        }
        setOpenConfirmationModal(true);
    }


    const handleAddImageField = () => {
        const newKey = `image${Object.keys(images).length + 1}`;
        setImageKeys((prev) => [...prev, newKey]);
    };

    const handleAddVehicleImageField = () => {
        const newKey = `image${Object.keys(images).length + 1}`;
        setImageKeysForVehicle((prev) => [...prev, newKey]);
    }

    const handleAddImageCompanyField = () => {
        const newKey = `image${Object.keys(images).length + 1}`;
        setImageKeysCompany((prev) => [...prev, newKey]);
    };

    const [selectedVehicleNo, setSelectedVehicleNo] = useState(null);

    const handleSubmit = async (action, e, vehicleNo) => {
        console.log('hellow')
        e?.preventDefault();
        // setIsSubmitting(true);




        const formDataObj = new FormData();
        for (const key in formData) {
            if (formData[key] !== undefined && formData[key] !== null && formData[key] !== "") {
                if (key === "rate" || key === "perHR") {
                    formDataObj.append(key, formData[key] === "" ? "0" : formData[key]);
                } else {
                    formDataObj.append(key, formData[key]);
                }
            }
        }
        for (const key in newImages) {
            const file = images[key];
            if (file instanceof File) {
                formDataObj.append(`images[${key}]`, file, file.name);
            }
        }


        for (let pair of formDataObj.entries()) {
            console.log(`${pair[0]}:`, pair[1]);
        }
        // return;
        try {
            const response = await axios.put(
                `${process.env.REACT_APP_BACKEND_URL}/api/updatedDetailsFromVendor`,
                formDataObj,
                {
                    headers: { "Content-Type": "multipart/form-data" },
                }
            );


            if (response.data) {
                // 1. Close this vehicle box
                setIsOpenImage(prev => ({ ...prev, [vehicleNo]: false }));

                // 2. Track submitted vehicle
                setSubmittedVehicles(prev => {
                    const updated = [...prev, vehicleNo];

                    // 3. If all vehicles submitted, navigate
                    // if (updated.length === formData.vehicleNo.length) {
                    //     setTimeout(() => navigate('/NewVendorApproved'), 500); // small delay optional
                    // }
                    setIsSubmitting(false);

                    navigate('/All-Added-Vehicles')
                    return updated;
                });
            }
        } catch (error) {
            console.error("Error during form submission:", error);
            const errorMessage = error.response?.data?.message || "An error occurred";
            if (errorMessage === "jwt expired") {
                setTimeout(() => window.location.href = "/", 2000);
            }
        } finally {
            setIsSubmitting(false);
        }
    };

    const [manuallySelectedKeys, setManuallySelectedKeys] = useState(new Set());




    return (
        <div className="bg-white h-full">

            <div className="flex md:flex-row flex-col justify-center gap-[30px]">
                <div className="h-[100vh]">

                    <div className=" flex items-center justify-center gap-4 pt-1 ">

                    </div>

                    <div onClick={() => navigate(-1)} className='fixed top-6 left-3'>
                        <ArrowLeft className="text-black" />
                    </div>


                    {state?.details === 'reject' && (
                        <div className="fixed top-2 right-3 ">
                            <button className="border-black border-2 py-1 bg-red-700 font-semibold text-white px-4 mb-2 rounded-xl" onClick={() => setIsRejected(!isRejected)}>
                                view reason
                            </button>
                        </div>
                    )}

                    {/* {formData.typeOfAgreement === "individual" && (
                        <form
                            className=" font-satoshi max-w-xl mx-auto p-4 bg-white rounded-md space-y-4 mb-5 "
                        >

                            {nextPage == 1 && (
                                <div>
                                    <div className="flex  md:flex-row items-center justify-between gap-2 p-2">
                                        <img src="https://cdn.pixabay.com/photo/2020/07/01/12/58/icon-5359553_640.png" className="h-[40px] w-[40px] mt-2" alt="" />
                                        <h2 className="text-xl font-semibold text-center my-2">OWNER INFORMATION</h2>

                                    </div>


                                    {["vehicleNo", "vendorName", "fatherName", "vendorPhone", "state", "city", "address"].map((field) => (
                                        <div key={field} className="flex flex-col">
                                            <label
                                                htmlFor={field}
                                                className="mb-1 mt-3 text-sm font-medium text-gray-700 capitalize font-semibold text-[12px]"
                                            >
                                                {field.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase())}
                                            </label>



                                            {field === "address" ? (
                                                <textarea
                                                    id={field}
                                                    name={field}
                                                    value={formData[field]}
                                                    placeholder={`Enter ${field.replace(/_/g, " ")}`}
                                                    onChange={handleInputChange}
                                                    className="font-satoshi border border-[#DEDEE8] bg-[#F6F6F6] rounded-[7px] pl-[15px] py-[16px] px-[10px] w-full"
                                                    rows={4}
                                                />
                                            ) : field === "state" ? (
                                                // Handle state dropdown
                                                <select
                                                    id={field}
                                                    name={field}
                                                    value={formData[field]}
                                                    onChange={handleInputChange}
                                                    disabled={isLoadingStates}
                                                    className=" font-satoshi border border-[#DEDEE8] bg-[#F6F6F6] rounded-[7px] pl-[15px] py-[16px] px-[10px] w-full"
                                                >
                                                    <option value="">Select State</option>
                                                    {states.map(state => (
                                                        <option key={state.iso2} value={state.iso2}>{state.name}</option>
                                                    ))}
                                                </select>
                                            ) : field === "city" ? (
                                                // Handle city dropdown
                                                <select
                                                    id={field}
                                                    name={field}
                                                    value={formData[field]}
                                                    onChange={handleInputChange}
                                                    disabled={isLoadingCities || !formData.state}
                                                    className="border border-[#DEDEE8] bg-[#F6F6F6] rounded-[7px] pl-[15px] py-[16px] px-[10px] w-full"
                                                >
                                                    <option value="">Select City</option>
                                                    {!cities.error && cities.map(city => (
                                                        <option key={city.name} value={city.name}>
                                                            {city.name}
                                                        </option>
                                                    ))}
                                                </select>
                                            ) : (
                                                // Handle regular input
                                                <input
                                                    id={field}
                                                    name={field}
                                                    value={formData[field]}
                                                    placeholder={`Enter ${field.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase())}`}

                                                    onChange={(e) => {
                                                        let value = e.target.value;

                                                        // Capitalize owner_name and father_name
                                                        if (["vendorName", "fatherName"].includes(field)) {
                                                            value = value.toUpperCase();
                                                        }

                                                        // Restrict mobile_no to 10 digits only
                                                        if (field === "vendorPhone") {
                                                            value = value.replace(/\D/g, "").slice(0, 10);
                                                        }

                                                        handleInputChange({ target: { name: field, value } });
                                                    }}
                                                    className="border border-[#DEDEE8] bg-[#F6F6F6] rounded-[7px] pl-[15px] py-[16px] px-[10px] w-full"
                                                    style={{ padding: "20px" }}
                                                />
                                            )}
                                        </div>
                                    ))}

                                    <div className="flex justify-center fixed bottom-0 left-0 right-0 z-[10] md:relative md:bottom-auto md:left-auto md:right-auto">
                                        <div className="mobile-only-shadow flex items-center justify-between bg-white p-2 rounded-t-xl w-full max-w-[30rem] gap-[0.5rem] mx-auto md:rounded-none md:p-0 md:bg-transparent">

                                            <button
                                                onClick={() => setNextPage(2)}
                                                className={`flex items-center justify-center gap-2 text-white text-base font-medium py-3 px-2 rounded-full transition-all w-full 
                                            bg-[#21A6E9] hover:bg-[#1e94d6]`}
                                            >
                                                Continue
                                                <img src={rightArrow} alt="Back" className="h-[24px] w-[24px]" />
                                            </button>

                                            <div className="flex-grow max-w-[5rem] min-w-[1rem]"></div>

                                        </div>
                                    </div>
                                </div>
                            )}

                            {nextPage == 2 && (
                                <div>
                                    <div className="flex gap-3">
                                        <img src="https://cdn.pixabay.com/photo/2016/01/03/00/43/upload-1118929_640.png" className="h-[40px] w-[40px] mt-3" alt="" />
                                        <h2 className="text-xl font-semibold text-center my-2">VIEW IMAGES</h2>
                                    </div>
                                    <div className="mb-[3rem] bg-[linear-gradient(175deg,_#ffffff,_transparent)] md:bg-[#ffffff] md:w-full rounded-[30px] md:p-[78px] max-w-[1148px] mx-auto p-2">

                                        <div className='font-satoshi'>

                                            <div hidden className="flex gap-3">
                                                <img src="https://cdn.pixabay.com/photo/2016/01/03/00/43/upload-1118929_640.png" className="h-[10%] w-[10%] mt-3" alt="" />
                                                <h2 className="text-[1rem] font-semibold text-center my-4">VIEW IMAGES</h2>
                                            </div>

                                            <div className="overflow-auto grid grid-cols-2 lg:grid-cols-2 gap-[0.7rem]">
                                                {imageKeys.map((key) => (
                                                    <div>
                                                        <div key={key} style={{ border: '2px dotted gray' }} className="flex flex-col relative p-[0.2rem] rounded-md rounded-xl ">
                                                            {images[key] ? (
                                                                <div className="relative w-full h-[6rem] mb-2 rounded-[10%] ">
                                                                    <img
                                                                        src={images[key] instanceof File ? URL.createObjectURL(images[key]) : images[key]}
                                                                        alt={key}
                                                                        className="w-full h-[7rem] rounded-xl object-cover"
                                                                    />
                                                                    {isNotReadOnly && imageReasonMap?.[key] && (
                                                                        <button
                                                                            type="button"
                                                                            onClick={() =>
                                                                                setImages((prev) => {
                                                                                    const newImages = { ...prev };
                                                                                    delete newImages[key];
                                                                                    return newImages;
                                                                                })
                                                                            }
                                                                            className="absolute top-1 right-1 bg-red-500 text-white rounded-full w-5 h-5 flex items-center justify-center text-xs"
                                                                            title="Remove this image"
                                                                        >
                                                                            ❌
                                                                        </button>
                                                                    )}
                                                                </div>

                                                            ) : (
                                                                <div className="flex flex-col items-center justify-center mt-[2rem]">
                                                                    <button
                                                                        type="button"
                                                                        style={{ background: 'rgb(140 140 140)' }}
                                                                        className="relative center-button text-white p-2 rounded-full shadow-lg hover:bg-black focus:outline-none"
                                                                        onClick={() => document.getElementById(`hiddenFileInput-${key}`).click()}
                                                                    >
                                                                        <AddIcon />
                                                                    </button>
                                                                    <input
                                                                        type="file"
                                                                        id={`hiddenFileInput-${key}`}
                                                                        accept="image/*"
                                                                        onChange={(e) => handleImageChange(key, e.target.files[0])}
                                                                        className=" form-control text-xs hidden opacity-0"
                                                                    />
                                                                </div>

                                                            )}
                                                        </div>
                                                        <label className="mb-1 text-sm font-medium font-semibold text-[12px] text-gray-700 mt-[1rem] text-center">
                                                            {key.charAt(0).toUpperCase() + key.slice(1)}
                                                        </label>
                                                    </div>
                                                ))}
                                            </div>


                                        </div>
                                    </div>

                                    {alertInfo.show && (
                                        <Alert severity={alertInfo.severity} onClose={() => setAlertInfo({ ...alertInfo, show: false })}>
                                            {alertInfo.message}
                                        </Alert>
                                    )}

                                    <div className="flex justify-center fixed bottom-0 left-0 right-0 z-[10] md:relative md:bottom-auto md:left-auto md:right-auto" >

                                        <div className="mobile-only-shadow flex items-center justify-between bg-white p-2 rounded-t-xl w-full max-w-[30rem] gap-[0.5rem] mx-auto md:rounded-none md:p-0 md:bg-transparent">
                                            <button
                                                onClick={() => setNextPage(1)}
                                                className="flex items-center justify-center gap-2 bg-[#EE3840] hover:bg-[#d32f2f] text-white text-base font-medium py-3 px-1 rounded-full transition-all w-full"
                                            >
                                                <img src={rightArrow} alt="Continue" className="h-[24px] w-[24px] scale-x-[-1]" />
                                                Back
                                            </button>



                                                    {state?.details !== 'reject' && (<button
                                                onClick={() => { navigate('/All-Added-Vehicles') }}
                                                className={`flex items-center justify-center gap-2 text-white text-base font-medium py-3 px-2 rounded-full transition-all w-full 
                                                                bg-[#21A6E9] hover:bg-[#1e94d6]`}
                                            >

                                                Close
                                            </button>)}

                                            {state?.details == 'reject' && (
                                                <button
                                                    onClick={readyToSubmit}
                                                    className={`flex items-center justify-center gap-2 text-white text-base font-medium py-3 px-2 rounded-full transition-all w-full 
                                                                bg-[#21A6E9] hover:bg-[#1e94d6]`}
                                                >

                                                    Submit
                                                </button>)}




                                            <div className="flex-grow max-w-[5rem] min-w-[1rem]"></div>

                                        </div>
                                    </div>
                                </div>
                            )}
                        </form>
                    )} */}

                    {/* {formData.typeOfAgreement === "non-individual" && ( */}
                    <div>
                        {/* {nextPage === 1 && (
                                <form className=" font-satoshi max-w-xl mx-auto p-4 bg-white rounded-md space-y-4 mb-5 ">



                                    <div className="flex  md:flex-row items-center justify-around gap-1 p-2">
                                        <img src="https://cdn.pixabay.com/photo/2020/07/01/12/58/icon-5359553_640.png" className="h-[40px] w-[40px] mt-3" alt="" />
                                        <h2 className="text-xl font-semibold text-center my-2 mt-4">COMPANY INFORMATION</h2>

                                    </div>
                                    {["vehicleNo", "vendorName", "companyName", "fatherName", "vendorPhone", "state", "city", "address"].map((field) => (
                                        <div key={field} className="flex flex-col">
                                            <label
                                                htmlFor={field}
                                                className="mb-1 text-sm font-medium text-gray-700 capitalize font-semibold text-[12px]"
                                            >
                                                {field.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase())}
                                            </label>

                                            {field === "address" ? (
                                                <textarea
                                                    id={field}
                                                    name={field}
                                                    value={formData[field]}
                                                    placeholder={`Enter ${field.replace(/_/g, " ")}`}
                                                    onChange={handleInputChange}
                                                    className="font-satoshi border border-[#DEDEE8] bg-[#F6F6F6] rounded-[7px] pl-[15px] py-[16px] px-[10px] w-full"
                                                    rows={4}
                                                    readOnly={!isNotReadOnly}
                                                />
                                            ) : field === "vehicleNo" ? (
                                                <div className="flex flex-col gap-2">
                                                    <div className="flex gap-2">
                                                        <input
                                                            id={field}
                                                            name={field}
                                                            value={formData.vehicleNo}
                                                            placeholder={`Enter ${field.replace(/_/g, " ")}`}
                                                            // onChange={(e)=> setFormData.vehicleNo}
                                                            onChange={(e) =>
                                                                setFormData((prev) => ({
                                                                    ...prev,
                                                                    vehicleNo: e.target.value,
                                                                }))
                                                            }
                                                            className="font-satoshi border border-[#DEDEE8] bg-[#F6F6F6] rounded-[7px] pl-[15px] py-[16px] px-[10px] w-full"
                                                            readOnly={!isNotReadOnly}
                                                        />
                                                    </div>
                                                </div>
                                            ) : (
                                                <input
                                                    id={field}
                                                    name={field}
                                                    value={formData[field]}
                                                    placeholder={`Enter ${field.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase())}`}

                                                    onChange={(e) => {
                                                        let value = e.target.value;

                                                        if (["vendorName", "fatherName"].includes(field)) {
                                                            value = value.toUpperCase();
                                                        }

                                                        if (field === "vendorPhone") {
                                                            value = value.replace(/\D/g, "").slice(0, 10);
                                                        }

                                                        handleInputChange({ target: { name: field, value } });
                                                    }}
                                                    className="border border-[#DEDEE8] bg-[#F6F6F6] rounded-[7px] pl-[15px] py-[16px] px-[10px] w-full"
                                                    style={{ padding: "20px" }}
                                                    readOnly={!isNotReadOnly}
                                                />
                                            )}
                                        </div>
                                    ))}



                                    <div className="flex justify-center fixed bottom-0 left-0 right-0 z-[10] md:relative md:bottom-auto md:left-auto md:right-auto">
                                        <div className="mobile-only-shadow flex items-center justify-between bg-white p-2 rounded-t-xl w-full max-w-[30rem] gap-[0.5rem] mx-auto md:rounded-none md:p-0 md:bg-transparent">

                                            <button
                                                onClick={() => setNextPage(2)}
                                                className={`flex items-center justify-center gap-2 text-white text-base font-medium py-3 px-2 rounded-full transition-all w-full 
                                                                bg-[#21A6E9] hover:bg-[#1e94d6]`}
                                            >
                                                Continue
                                                <img src={rightArrow} alt="Back" className="h-[24px] w-[24px]" />
                                            </button>

                                            <div className="flex-grow max-w-[5rem] min-w-[1rem]"></div>

                                        </div>
                                    </div>




                                </form>
                            )}

                            {nextPage === 2 && (
                                <form className="font-satoshi max-w-xl mx-auto p-4 bg-white rounded-md space-y-4 mb-5 md:min-w-[400px]">

                                    <div className="flex  md:flex-row items-center justify-between gap-2 p-2">
                                        <h2 className="text-xl font-semibold text-center my-2">VIEW IMAGES</h2>

                                    </div>

                                    <div className="overflow-auto grid grid-cols-2 lg:grid-cols-2 gap-[0.7rem]">
                                        {imageKeys
                                            .filter(
                                                (key) =>
                                                    !formData.vehicleNo.some((v) => key.includes(v)) && // Exclude keys that include vehicle numbers
                                                    !/\d/.test(key) // Exclude keys that contain any number
                                            )
                                            .map((key) => (
                                                <div key={key}>
                                                    <div style={{ border: '2px dotted gray' }} className="flex flex-col relative p-[0.2rem] rounded-md rounded-xl">
                                                        {images[key] ? (
                                                            <>
                                                                <div className="relative w-full h-[6rem] mb-2 rounded-[10%] ">
                                                                    <img
                                                                        src={images[key] instanceof File ? URL.createObjectURL(images[key]) : images[key]}
                                                                        alt={key}
                                                                        onClick={() =>
                                                                            setModalImage(
                                                                                images[key] instanceof File ? URL.createObjectURL(images[key]) : images[key]
                                                                            )
                                                                        }
                                                                        className="w-full h-[6rem] rounded-xl object-cover cursor-pointer"
                                                                    />
                                                                    {isNotReadOnly && imageReasonMap?.[key] && (
                                                                        <button
                                                                            type="button"
                                                                            onClick={() =>
                                                                                setImages((prev) => {
                                                                                    const newImages = { ...prev };
                                                                                    delete newImages[key];
                                                                                    return newImages;
                                                                                })
                                                                            }
                                                                            className="absolute top-1 right-1 bg-red-500 text-white rounded-full w-5 h-5 flex items-center justify-center text-xs"
                                                                            title="Remove this image"
                                                                        >
                                                                            ❌
                                                                        </button>
                                                                    )}

                                                                </div>
                                                            </>
                                                        ) : (
                                                            <div className="flex flex-col items-center justify-center mt-[2rem]">
                                                                <button
                                                                    type="button"
                                                                    style={{ background: 'rgb(140 140 140)' }}
                                                                    className="relative center-button text-white p-2 rounded-full shadow-lg hover:bg-black focus:outline-none"
                                                                    onClick={() => document.getElementById(`hiddenFileInput-${key}`).click()}
                                                                >
                                                                    <AddIcon />
                                                                </button>
                                                                <input
                                                                    type="file"
                                                                    id={`hiddenFileInput-${key}`}
                                                                    accept="image/*"
                                                                    onChange={(e) => handleImageChange(key, e.target.files[0])}
                                                                    className=" form-control text-xs hidden opacity-0"
                                                                />
                                                            </div>

                                                        )}
                                                    </div>
                                                    <label className="mb-1 text-sm font-medium font-semibold text-[12px] text-gray-700 mt-[0.5rem] text-center">
                                                        {key.charAt(0).toUpperCase() + key.slice(1)}
                                                    </label>
                                                </div>
                                            ))}
                                    </div>


                                    {modalImage && (
                                        <div
                                            onClick={() => setModalImage(null)}
                                            style={{ backgroundImage: 'linear-gradient(#fefefe36, #656565)' }}
                                            className="fixed inset-0 z-50 flex items-center justify-center"
                                        >
                                            <div
                                                onClick={(e) => e.stopPropagation()}
                                                className="bg-white p-4 rounded-lg shadow-lg max-w-[95%] max-h-[95%] overflow-hidden relative"
                                            >
                                                <img
                                                    src={modalImage}
                                                    alt="Preview"
                                                    className="max-w-full max-h-[90vh] rounded-md object-cover"
                                                />

                                                <button
                                                    onClick={() => setModalImage(null)}
                                                    className="absolute top-2 right-2 text-1xl text-gray-600 hover:text-black focus:outline-none"
                                                    title="Close"
                                                >
                                                    ❌
                                                </button>
                                            </div>
                                        </div>

                                    )}





                                    <div className="flex justify-center fixed bottom-0 left-0 right-0 z-[10] md:relative md:bottom-auto md:left-auto md:right-auto">
                                        <div className="mobile-only-shadow flex items-center justify-between bg-white p-2 rounded-t-xl w-full max-w-[30rem] gap-[0.5rem] mx-auto md:rounded-none md:p-0 md:bg-transparent">
                                            <button
                                                onClick={() => setNextPage(1)}
                                                className="flex items-center justify-center gap-2 bg-[#EE3840] hover:bg-[#d32f2f] text-white text-base font-medium py-3 px-1 rounded-full transition-all w-full"
                                            >
                                                <img src={rightArrow} alt="Continue" className="h-[24px] w-[24px] scale-x-[-1]" />
                                                Back
                                            </button>
                                            <button
                                                onClick={() => setNextPage(3)}
                                                className={`flex items-center justify-center gap-2 text-white text-base font-medium py-3 px-2 rounded-full transition-all w-full 
                                                                bg-[#21A6E9] hover:bg-[#1e94d6]`}
                                            >
                                                Continue
                                                <img src={rightArrow} alt="Back" className="h-[24px] w-[24px]" />
                                            </button>

                                            <div className="flex-grow max-w-[5rem] min-w-[1rem]"></div>

                                        </div>
                                    </div>
                                </form>
                            )} */}

                        {/* {nextPage === 3 && ( */}
                        <form className="font-satoshi max-w-xl mx-auto p-4 bg-white rounded-md space-y-4 mb-5 md:min-w-[400px]">


                            <div className="flex  md:flex-row items-center justify-between gap-2 p-2">
                                <h2 className="text-xl font-semibold text-center my-2">VIEW IMAGES</h2>

                            </div>

                            <div className="w-full">
                                {formData.vehicleNo.map((vehicleNo) => (
                                    <div key={vehicleNo} className="mb-6">
                                        <div
                                            {...(isOpenImage[vehicleNo] && {
                                            })}
                                        >
                                            <div onClick={() => toggleVehicleImage(vehicleNo)} className="flex items-center justify-between px-3 py-1 mt-1 rounded">
                                                <div className="text-sm font-semibold text-black">
                                                    {vehicleNo}
                                                </div>
                                                {isOpenImage[vehicleNo] ? (
                                                    <ChevronDown
                                                        className="text-black h-6 p-1 bg-gray-200 rounded-full"
                                                    />
                                                ) : (
                                                    <ChevronUp
                                                        className="text-black h-6 p-1 bg-gray-200 rounded-full"
                                                    />
                                                )}
                                            </div>
                                            {isOpenImage[vehicleNo] && (
                                                <div className="mt-2">
                                                    <input
                                                        name={`driverName-${vehicleNo}`}
                                                        value={formData[`driverName-${vehicleNo}`] || ""}
                                                        placeholder="Enter Driver Name"
                                                        onChange={(e) => {
                                                            const { name, value } = e.target;
                                                            setFormData((prev) => ({
                                                                ...prev,
                                                                [name]: value,
                                                            }));
                                                        }}
                                                        readOnly={!isNotReadOnly}
                                                        style={{ border: '1px solid' }}
                                                        className=" border-[#DEDEE8] bg-[#F6F6F6] rounded-[7px] pl-[15px] py-[16px] px-[10px] w-[95%] m-2"
                                                    />

                                                    <input
                                                        name={`driverNumber-${vehicleNo}`}
                                                        value={formData[`driverNumber-${vehicleNo}`] || ""}
                                                        placeholder="Enter Driver Number"
                                                        onChange={(e) => {
                                                            const { name, value } = e.target;
                                                            setFormData((prev) => ({
                                                                ...prev,
                                                                [name]: value,
                                                            }));
                                                        }}
                                                        readOnly={!isNotReadOnly}
                                                        style={{ border: '1px solid' }}
                                                        className=" border-[#DEDEE8] bg-[#F6F6F6] rounded-[7px] pl-[15px] py-[16px] px-[10px] w-[95%] m-2"
                                                    />
                                                    <input
                                                        name={`driverDLNos-${vehicleNo}`}
                                                        value={formData[`driverDLNos-${vehicleNo}`] || ""}
                                                        placeholder="Enter Driver DL"
                                                        onChange={(e) => {
                                                            const { name, value } = e.target;
                                                            setFormData((prev) => ({
                                                                ...prev,
                                                                [name]: value,
                                                            }));
                                                        }}
                                                        readOnly={!isNotReadOnly}
                                                        style={{ border: '1px solid' }}
                                                        className=" border-[#DEDEE8] bg-[#F6F6F6] rounded-[7px] pl-[15px] py-[16px] px-[10px] w-[95%] m-2"
                                                    />

                                                    <input
                                                        type="date"
                                                        name={`driverDOBs-${vehicleNo}`}
                                                        value={formData.driverDOBs?.[vehicleNo] || ""}
                                                        placeholder="Enter Driver DOBs"
                                                        onChange={(e) => {
                                                            const { value } = e.target;
                                                            setFormData((prev) => ({
                                                                ...prev,
                                                                driverDOBs: {
                                                                    ...prev.driverDOBs,
                                                                    [vehicleNo]: value,
                                                                },
                                                            }));
                                                        }}                                                       
                                                        readOnly={!isNotReadOnly}
                                                        style={{ border: '1px solid' }}
                                                        className="border-[#DEDEE8] bg-[#F6F6F6] rounded-[7px] pl-[15px] py-[16px] px-[10px] w-[95%] m-2"
                                                    />


                                                    <div style={{ background: 'linear-gradient(#ffffff, #d5d7d5)' }} className="relative flex flex-col mt-3 p-2 rounded-xl min-h-[300px]">
                                                        <div className="grid grid-cols-2 gap-4">
                                                            {imageKeys.filter((key) => {
                                                                const matchesVehicle = key.includes(vehicleNo);
                                                                const showOnlyReasons = imageReasonMap && Object.keys(imageReasonMap).length > 0;
                                                                const isInReasonMap = imageReasonMap?.[key];
                                                                return matchesVehicle && (!showOnlyReasons || isInReasonMap);
                                                            }).map((key) => (
                                                                <div>
                                                                    <div key={key} style={{ border: '2px dotted gray' }} className="flex flex-col p-[0.2rem] rounded-xl">
                                                                        {images[key] ? (
                                                                            <div className="relative w-full h-[6rem] mb-2 rounded-md">
                                                                                {(() => {
                                                                                    const fileUrl = images[key] instanceof File ? URL.createObjectURL(images[key]) : images[key];
                                                                                    console.log('fileUrl', fileUrl)
                                                                                    const isPdf = fileUrl.toLowerCase().endsWith('.pdf');
                                                                                    console.log('isPdf', isPdf)

                                                                                    return isPdf ? (
                                                                                        <div onClick={() => setModalImage(fileUrl)} className="w-full h-[6rem] border border-gray-300 rounded-xl flex items-center justify-center cursor-pointer bg-gray-100 hover:bg-gray-200">
                                                                                            <span className="text-sm text-gray-700">Click to open PDF</span>
                                                                                        </div>
                                                                                    ) : (
                                                                                        <img
                                                                                            src={fileUrl}
                                                                                            alt={key}
                                                                                            onClick={() => setModalImage(fileUrl)}
                                                                                            className="w-full h-[6rem] rounded-xl object-cover cursor-pointer"
                                                                                        />
                                                                                    );
                                                                                })()}
                                                                                {isNotReadOnly && imageReasonMap?.[key] && (
                                                                                    <button
                                                                                        type="button"
                                                                                        onClick={() => {
                                                                                            setImages((prev) => {
                                                                                                const newImages = { ...prev };
                                                                                                delete newImages[key];
                                                                                                return newImages;
                                                                                            });
                                                                                            setManuallySelectedKeys((prev) => {
                                                                                                const updated = new Set(prev);
                                                                                                updated.delete(key);
                                                                                                return updated;
                                                                                            });
                                                                                        }}
                                                                                        className={`absolute ${manuallySelectedKeys.has(key)
                                                                                            ? 'top-1 right-1 w-5 h-5' // user selected image → top-right
                                                                                            : 'top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[4.5rem] h-[4.5rem]' // otherwise center
                                                                                            } text-center text-red-800 rounded-full flex items-center justify-center text-xs`}
                                                                                        style={{ background: 'radial-gradient(#f8f4f4, #ffffff14)' }}
                                                                                        title="Remove this image"
                                                                                    >
                                                                                        <Trash2 className="w-full h-full" />
                                                                                    </button>

                                                                                )}
                                                                            </div>
                                                                        ) : (
                                                                            <div className="flex flex-col items-center justify-center mt-[2rem]">
                                                                                <button
                                                                                    type="button"
                                                                                    style={{ background: 'rgb(140 140 140)' }}
                                                                                    className="relative center-button text-white p-2 rounded-full shadow-lg hover:bg-black focus:outline-none"
                                                                                    onClick={() => document.getElementById(`hiddenFileInput-${key}`).click()}
                                                                                >
                                                                                    <AddIcon />
                                                                                </button>
                                                                                <input
                                                                                    type="file"
                                                                                    id={`hiddenFileInput-${key}`}
                                                                                    accept="image/*"
                                                                                    onChange={(e) => handleImageChange(key, e.target.files[0])}
                                                                                    className=" form-control text-xs hidden opacity-0"
                                                                                />
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                    <label className="block text-center text-sm mt-2">
                                                                        {key}
                                                                    </label>
                                                                </div>
                                                            ))}
                                                        </div>

                                                        {/* Button placed at the bottom of the full flex container */}

                                                    </div>


                                                </div>



                                            )}
                                        </div>
                                    </div>
                                ))}
                            </div>

                            {
                                alertInfo.show && (
                                    <Alert severity={alertInfo.severity} onClose={() => setAlertInfo({ ...alertInfo, show: false })}>
                                        {alertInfo.message}
                                    </Alert>
                                )
                            }

                            <div className="flex justify-center fixed bottom-0 left-0 right-0 z-[10] md:relative md:bottom-auto md:left-auto md:right-auto" >
                                <div className="mobile-only-shadow flex items-center justify-between bg-white p-2 rounded-t-xl w-full max-w-[30rem] gap-[0.5rem] mx-auto md:rounded-none md:p-0 md:bg-transparent">
                                    <button
                                        onClick={() => navigate('/AllAddedVehiclesNew')}
                                        className="flex items-center justify-center gap-2 bg-[#EE3840] hover:bg-[#d32f2f] text-white text-base font-medium py-3 px-1 rounded-full transition-all w-full"
                                    >
                                        <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/navbar/right-arrow.svg' alt="Continue" className="h-[24px] w-[24px] scale-x-[-1]" />
                                        Back
                                    </button>

                                    {state?.details !== 'reject' && (<button
                                        type="button"
                                        onClick={() => navigate('/AllAddedVehiclesNew', { replace: true })}
                                        className={`flex items-center justify-center gap-2 text-white text-base font-medium py-3 px-2 rounded-full transition-all w-full 
                                                                bg-[#21A6E9] hover:bg-[#1e94d6]`}
                                    >

                                        Close
                                    </button>)}

                                    {state?.details == 'reject' && (
                                        <button
                                            onClick={readyToSubmit}
                                            className={`flex items-center justify-center gap-2 text-white text-base font-medium py-3 px-2 rounded-full transition-all w-full 
                                                                bg-[#21A6E9] hover:bg-[#1e94d6]`}
                                        >

                                            Submit
                                        </button>)}



                                    <div className="flex-grow max-w-[5rem] min-w-[1rem]"></div>

                                </div>
                            </div>

                            {modalImage && (
                                <div
                                    onClick={() => setModalImage(null)}
                                    style={{ backgroundImage: 'linear-gradient(#fefefe36, #656565)' }}
                                    className="fixed inset-0 z-50 flex items-center justify-center z-[1000]"
                                >
                                    <div
                                        onClick={(e) => e.stopPropagation()}
                                        className="bg-white p-4 rounded-lg shadow-lg max-w-[95%] max-h-[95%] overflow-hidden relative"
                                    >
                                        {modalImage.toLowerCase().endsWith('.pdf') ? (
                                            <iframe
                                                src={modalImage}
                                                title="PDF Preview"
                                                className="min-w-full min-h-[90vh] rounded-md object-cover"

                                            />
                                        ) : (
                                            <img
                                                src={modalImage}
                                                alt="Preview"
                                                className="max-w-full max-h-[90vh] rounded-md object-cover"
                                            />
                                        )}

                                        <button
                                            onClick={() => setModalImage(null)}
                                            className="absolute top-2 right-2 text-1xl text-gray-600 hover:text-black focus:outline-none"
                                            title="Close"
                                        >
                                            ❌
                                        </button>
                                    </div>
                                </div>
                            )}

                        </form>
                        {/* )} */}
                    </div>
                    {/* )} */}


                    <Modal
                        isOpen={isModalOpen}
                        onClose={() => setIsModalOpen(false)}
                        chooseFromSelectedService={formData.chooseFromSelectedService}
                        ReasonOfRejection={formData.ReasonOfRejection}
                        onChange={handleInputChange}
                        handleSubmit={handleSubmit}
                        selectedVehicleNo={selectedVehicleNo}
                        isSubmitting={isSubmitting}
                    />

                    <ConfirmationModal
                        isOpen={openConfirmationModal}
                        onClose={() => setOpenConfirmationModal(false)}
                        handleSubmit={handleSubmit}
                    />

                    <RejectionReasonModal
                        isOpen={isRejected}
                        onClose={() => setIsRejected(false)}
                        imageReasonMap={imageReasonMap}
                        otherReason={parsedReasons?.other}
                    />
                    <ValidationFailedModal
                        isOpen={openValidationModal}
                        onClose={() => setOpenValidationModal(false)}
                    />
                </div>
                <div className=' hidden sm:block w-full mt-[5rem] p-5 max-w-[555px]'>
                    <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/add/img6.png' className='w-[400px] h-[400px]' alt="" />
                </div>
            </div>
        </div>


    );
};

export default ViewDetails;


function Modal({ isOpen, onClose, chooseFromSelectedService, ReasonOfRejection, onChange, handleSubmit, isSubmitting }) {
    const [submittingType, setSubmittingType] = useState(null);

    useEffect(() => {
        if (!isOpen) setSubmittingType(null);
    }, [isOpen]);

    const handleSelectChange = (e) => {
        onChange(e); // update parent
        if (e.target.value !== '') {
            onChange({ target: { name: 'ReasonOfRejection', value: '' } }); // clear textarea
        }
    };

    const handleTextareaChange = (e) => {
        onChange(e); // update parent
        if (e.target.value !== '') {
            onChange({ target: { name: 'chooseFromSelectedService', value: '' } }); // clear dropdown
        }
    };

    const onSubmit = async (type) => {
        setSubmittingType(type);
        await handleSubmit(type);
        setTimeout(() => {
            setSubmittingType(null);
            onClose();
        }, 500);
    };

    if (!isOpen) return null;

    return (
        <div className="fixed font-satoshi inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[1000]">
            <div className="bg-white py-[42px] px-[50px] rounded-[30px] shadow-lg w-[90%] md:w-[536px] relative">
                <button
                    onClick={onClose}
                    className="absolute top-4 right-4 text-gray-500 hover:text-gray-800 text-xl font-bold focus:outline-none"
                >
                    &times;
                </button>
                <div className="grid grid-cols-1 pt-[40px] items-center gap-[18px]">
                    <div className="grid grid-cols-1 gap-4 mb-2">
                        {/* Dropdown */}
                        <div className="flex flex-col">
                            <label htmlFor="chooseFromSelectedService" className="text-sm font-medium text-gray-700 mb-1">
                                Choose Service Type
                            </label>
                            <select
                                id="chooseFromSelectedService"
                                name="chooseFromSelectedService"
                                value={chooseFromSelectedService}
                                onChange={handleSelectChange}
                                className="bg-gray-50 font-satoshi border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 p-2"
                            >
                                <option value="">Select</option>
                                <option value="mini">Mini</option>
                                <option value="medium">Medium</option>
                                <option value="large">Large</option>
                            </select>
                        </div>

                        {/* Textarea */}
                        <div className="flex flex-col">
                            <label htmlFor="ReasonOfRejection" className="text-sm font-medium text-gray-700 mb-1">
                                Reason of Rejection
                            </label>
                            <textarea
                                id="ReasonOfRejection"
                                name="ReasonOfRejection"
                                value={ReasonOfRejection}
                                onChange={handleTextareaChange}
                                rows={4}
                                placeholder="Optional reason..."
                                className="bg-gray-50 font-satoshi border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-red-500 focus:border-red-500 p-3 resize-none"
                            />
                        </div>
                    </div>



                    {/* Buttons */}
                    <div className="flex gap-2">
                        {/* Reject */}
                        <button
                            onClick={() => onSubmit('not_approved')}
                            disabled={chooseFromSelectedService !== '' || submittingType !== null}
                            className="flex items-center justify-center gap-2 bg-[#EE3840] hover:bg-[#d32f2f] text-white text-base font-medium py-3 px-1 rounded-full transition-all w-full disabled:bg-gray-300 disabled:cursor-not-allowed"
                        >
                            {submittingType === 'not_approved' ? (
                                <div className="flex gap-2 items-center">
                                    <ClipLoader size={20} color="#ffffff" />
                                    <p>Submitting...</p>
                                </div>
                            ) : (
                                "Reject"
                            )}
                        </button>

                        {/* Accept */}
                        <button
                            onClick={() => onSubmit('approved')}
                            disabled={ReasonOfRejection !== '' || chooseFromSelectedService === '' || submittingType !== null}
                            className="flex items-center justify-center gap-2 text-white text-base font-medium py-3 px-2 rounded-full transition-all w-full 
                            bg-[#21A6E9] hover:bg-[#1e94d6] disabled:bg-gray-300 disabled:cursor-not-allowed"
                        >
                            {submittingType === 'approved' ? (
                                <div className="flex gap-2 items-center">
                                    <ClipLoader size={20} color="#ffffff" />
                                    <p>Submitting...</p>
                                </div>
                            ) : (
                                "Accept"
                            )}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};


const RejectionReasonModal = ({ isOpen, onClose, imageReasonMap, otherReason }) => {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className=" m-2 bg-white rounded-2xl shadow-xl max-w-5xl w-full p-6 overflow-y-auto max-h-[50vh] relative">
                {/* Modal Header */}
                <div className="flex justify-between items-center mb-6">
                    <h2 className="text-2xl font-semibold text-gray-800">Rejection Reasons</h2>
                    <button
                        onClick={onClose}
                        className="text-gray-500 hover:text-red-500 text-2xl font-bold"
                        aria-label="Close"
                    >
                        ×
                    </button>
                </div>

                {/* Image + Reason List */}
                <div className="space-y-6">
                    {Object.entries(imageReasonMap).map(([key, { url, reason }]) => (
                        <div
                            key={key}
                            className="flex items-center gap-6 border border-gray-200 p-4 rounded-xl shadow-sm"
                        >
                            <img
                                src={url}
                                alt={key}
                                className="w-32 h-24 object-cover rounded-lg border"
                            />
                            <div className="flex flex-col justify-between">
                                <h3 className="text-lg font-medium text-gray-900 mb-1">{key}</h3>
                                <p className="text-sm text-red-600 font-normal">
                                    <span className="font-semibold">Reason:</span> {reason}
                                </p>
                            </div>
                        </div>
                    ))}
                </div>

                {/* Other Reason Section */}
                {otherReason && (
                    <div className="mt-8 border-t pt-5">
                        <h4 className="text-base font-medium text-gray-800 mb-1">Other Comments:</h4>
                        <p className="text-sm text-gray-600">{otherReason}</p>
                    </div>
                )}
            </div>
        </div>
    );
};

function ConfirmationModal({ isOpen, onClose, handleSubmit }) {
    if (!isOpen) return null;
    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg shadow-lg p-6 w-80 text-center">
                <h2 className="text-lg font-semibold mb-2"> Confirmation of Submission?</h2>
                <p className="text-gray-600 text-sm mb-6">
                    Are you sure you want to submit? You will not be able to change Details later.
                </p>
                <div className="flex justify-around text-sm">
                    <button
                        className="text-gray-700 hover:underline"
                        onClick={onClose}
                    >
                        Cancel
                    </button>
                    <button
                        className="text-blue-600 hover:underline font-medium"
                        onClick={() => {
                            onClose();
                            handleSubmit();
                        }}
                    >
                        Confirm
                    </button>
                </div>
            </div>
        </div>)
}

function ValidationFailedModal({ isOpen, onClose }) {
    if (!isOpen) return null;

    return (
        <div className="font-satoshi fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg shadow-lg p-6 w-80 text-left">
                <p className="text-gray-600 text-sm mb-6">
                    <span className="text-red-600">*</span> Please complete all required fields and upload necessary images before submitting the form.
                </p>
                <div className="flex justify-end">
                    <button
                        className="border-2 border-[#21A6E9] bg-white hover:bg-blue-600  py-1 px-6 rounded"
                        onClick={onClose}
                    >
                        Okay
                    </button>
                </div>
            </div>
        </div>
    );
}

// function RejectionModal({ isOpen, onClose }) {
//     if (!isOpen) return null;
//     return (
//         <div className="flex flex-col space-y-4">
//             <label className="text-sm font-medium text-gray-700 mb-2">
//                 Reason of Rejection
//             </label>

//             <div>
//                 {Object.keys(rejectedObject).length === 0 ? (
//                     // General reason textarea when no images are rejected
//                     <textarea
//                         rows={2}
//                         placeholder="Add reason..."
//                         onChange={(e) => {
//                             // Update the ReasonOfRejection field with the user's input
//                             onChange({
//                                 target: {
//                                     name: 'ReasonOfRejection',
//                                     value: e.target.value,
//                                 },
//                             });
//                         }}
//                         className="w-full bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg p-2 resize-none focus:ring-red-500 focus:border-red-500"
//                     />
//                 ) : (
//                     // Handling individual rejection reasons for each image
//                     <div>
//                         {Object.entries(rejectedObject).map(([key, imageUrl]) => (
//                             <div key={key} className="flex items-start space-x-4">
//                                 <img
//                                     src={imageUrl}
//                                     alt={key}
//                                     className="w-16 h-16 object-cover rounded-lg border border-red-400 mt-1"
//                                 />
//                                 <div className="flex-1">
//                                     <p className="text-sm font-semibold text-gray-800 mb-1">
//                                         {key.replace(/([A-Z])/g, " $1").replace(/\b\w/g, (l) => l.toUpperCase())}
//                                     </p>
//                                     <textarea
//                                         rows={2}
//                                         placeholder="Add reason for this image..."
//                                         value={rejectionReasons[key] || ""}
//                                         onChange={(e) => handleTextareaChange(e, key)} // handle individual image rejection reason
//                                         className="w-full bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg p-2 resize-none focus:ring-red-500 focus:border-red-500"
//                                     />
//                                 </div>
//                             </div>
//                         ))}
//                         {/* General reason textarea for non-image reasons */}
//                         <textarea
//                             rows={2}
//                             placeholder="Add general reason..."
//                             onChange={(e) => {
//                                 const generalReason = e.target.value;

//                                 // Combine general reason with individual image reasons
//                                 const updatedRejectionSummary = Object.entries(rejectionReasons)
//                                     .map(([key, reason]) => {
//                                         const label = key.replace(/([A-Z])/g, " $1").replace(/\b\w/g, (l) => l.toUpperCase());
//                                         return reason ? `• ${label}: ${reason}` : null;
//                                     })
//                                     .filter(Boolean)
//                                     .join("\n");

//                                 // Append the general reason to the rejection summary
//                                 const finalReasonOfRejection = `${updatedRejectionSummary}\n${generalReason}`;

//                                 // Update the ReasonOfRejection field in form data while preserving individual image reasons
//                                 onChange({
//                                     target: {
//                                         name: 'ReasonOfRejection',
//                                         value: finalReasonOfRejection,
//                                     },
//                                 });
//                             }}
//                             className="w-full bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg p-2 resize-none focus:ring-red-500 focus:border-red-500"
//                         />

//                     </div>
//                 )}
//             </div>

//         </div>
//     )
// }


